import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

const appointeesAPI = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBoardMembers: build.query<any, any>({
      queryFn: async () => {
        let { data } = await supabase
          .from("board_member")
          .select(
            "id,first_name,middle_initial,last_name,profile_url,appointment_date,description,is_active"
          )
          .eq("role", "BOARD")
          .order("last_name", { ascending: true });
        return { data };
      },
      providesTags: ["appointees"],
    }),
    getBoardMemberDetails: build.query<any, any>({
      queryFn: async (id: number) => {
        let { data } = await supabase
          .from("board_member")
          .select("*")
          .eq("id", id)
          .single();
        return { data };
      },
      providesTags: ["appointees"],
    }),
    AddBoardMember: build.mutation<any, any>({
      queryFn: async (boardMember: any) => {
        let { data } = await supabase
          .from("board_member")
          .insert(boardMember)
          .single();
        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
    updateBoardMember: build.mutation<any, any>({
      queryFn: async (boardMember: any) => {
        let { data } = await supabase
          .from("board_member")
          .update(boardMember)
          .eq("id", boardMember.id)
          .select();
        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
    // addMove: build.mutation<any, any>({
    //   queryFn: async (movie: any) => {
    //     let { data } = await supabase.from("movies").insert(movie).single();
    //     return { data };
    //   },
    //   invalidatesTags: ["movies"],
    // }),
    addBoardMember: build.mutation<any, any>({
      queryFn: async (boardMember: any) => {
        let { data } = await supabase
          .from("board_member")
          .insert(boardMember)
          .single();
        return { data };
      },
      invalidatesTags: ["appointees"],
    }),

    getOfficials: build.query<any, any>({
      queryFn: async () => {
        let { data } = await supabase
          .from("chairman")
          .select("*")
          .order("index", { ascending: true });
        return { data };
      },
      providesTags: ["appointees"],
    }),

    updateOfficial: build.mutation<any, any>({
      queryFn: async (official: any) => {
        let { data } = await supabase
          .from("chairman")
          .update(official)
          .eq("id", official.id)
          .select();
        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
    getCommittees: build.query<any, any>({
      queryFn: async () => {
        let { data } = await supabase
          .from("board_committees")
          .select("*")
          .order("name", { ascending: true });
        return { data };
      },
      providesTags: ["appointees"],
    }),
    getCommitteeMembers: build.query<any, any>({
      queryFn: async (id) => {
        let { data } = await supabase
          .from("board_committee_members")
          .select("*,member:board_member(*)")
          .eq("board_committee_id", id)
          .order("role", { ascending: true });
        return { data };
      },
      providesTags: ["appointees"],
    }),
    addCommittee: build.mutation<any, any>({
      queryFn: async (committee: any) => {
        let { data } = await supabase
          .from("board_committees")
          .insert(committee)
          .single();

        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
    updateCommittee: build.mutation<any, any>({
      queryFn: async (committee: any) => {
        // Ensure the user object has an id field to identify the row to update
        const { id, ...rest } = committee;
        if (!id) {
          return { error: { message: "ID is required for update" } };
        }
        let { data, error } = await supabase
          .from("board_committees")
          .update(rest)
          .eq("id", id)
          .select();
        if (error) {
          return { error };
        }

        return { data };
      },
      invalidatesTags: ["appointees"],
    }),

    addBoardMemberCommittee: build.mutation<any, any>({
      queryFn: async (memberCommittee: any) => {
        let { data } = await supabase
          .from("board_committee_members")
          .insert(memberCommittee)
          .single();

        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
    deleteBoardMemberCommittee: build.mutation<any, string>({
      queryFn: async (memberId: string) => {
        let { data, error } = await supabase
          .from("board_committee_members")
          .delete()
          .eq("id", memberId);

        if (error) {
          return { error };
        }

        return { data };
      },
      invalidatesTags: ["appointees"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetBoardMembersQuery,
  useGetBoardMemberDetailsQuery,
  useUpdateBoardMemberMutation,
  useAddBoardMemberMutation,
  useGetOfficialsQuery,
  useUpdateOfficialMutation,
  useGetCommitteesQuery,
  useGetCommitteeMembersQuery,
  useAddCommitteeMutation,
  useUpdateCommitteeMutation,
  useAddBoardMemberCommitteeMutation,
  useDeleteBoardMemberCommitteeMutation,
} = appointeesAPI;
